export function serializeMenuItemLabel(label: string) {
  return label.toLowerCase().replace(/\s+/g, '-');
}
